import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { LinkedProcesses } from '@core/entities/linkedProcesses'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const permitLinkedProcessTransform = (data: LinkedProcesses) => {
  return LinkedProcesses.new(data)
}

export const useGetPermitLinkedProcesses = (
  payload: RequestTypes['getPermitLinkedProcesses'],
  options?: UseQueryOptions<LinkedProcesses, RequestErrorType>,
) => {
  return useQuery({
    select: permitLinkedProcessTransform,
    ...permitKeys.byId(payload)._ctx.linkedProcesses,
    ...options,
  })
}
